import { ScrollObserver } from './libs/scroll';
import { MvSwiper } from './libs/swiper';

document.addEventListener('DOMContentLoaded', function () {
  const front = new Front();
});

class Front {
  constructor() {
    this.mvSlider = new MvSwiper('.js-swiper');
    this.mvSlider.start();
    this._observers = [];
    this._init();
  }

  set observers(val) {
    this._observers.push(val);
  }

  get observers() {
    return this._observers;
  }

  _init() {
    // this._scrollIniti();
  }

  _inviewAnimation(el, inview) {
    if (inview) {
      el.classList.add('inview');
    } else {
      el.classList.remove('inview');
    }
  }

  _scrollIniti() {
    this.observers = new ScrollObserver('.appear', this._inviewAnimation, {
      rootMargin: '-300px 0px',
    });
  }
}
